<app-dialog
	modalTitle="Grupos de usuários"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	(dialogClose)="closeModal()"
	(dialogSave)="saveItems()"
>
	<ul class="mb-fix">
		<li *ngFor="let group of data.groups; let idx = index">
			<mat-checkbox
				color="primary"
				class="ml-xs mt-nano mb-nano"
				[checked]="resultIds.includes(group.id)"
				[disabled]="
					data.disabled === group.id || disableAllButOperator(group.name)
				"
				(change)="onCheckboxToggle(group.id, $event.checked)"
			>
				<span id="group-name">{{ getGroupLabel(group.name) }}</span>
			</mat-checkbox>
		</li>
	</ul>
</app-dialog>
